export const KATEGORIEN = [
  { value: "wichtige_mitteilungen", label: "Wichtige Mitteilungen", icon: "AlertTriangle", accent: "amber" },
  { value: "einzelhaft_uhaft", label: "Einzelhaft / U-Haft", icon: "Lock", accent: "red" },
  { value: "langfristige", label: "Langfristige Informationen", icon: "CalendarRange", accent: "blue" },
  { value: "kurzfristige", label: "Kurzfristige Informationen", icon: "Clock", accent: "blue" },
  { value: "reminder", label: "Reminder", icon: "Bell", accent: "blue" },
  { value: "telefon_zellen", label: "Telefon Zellen", icon: "Phone", accent: "blue" },
];

export const KATEGORIE_LABEL = KATEGORIEN.reduce((a, k) => ({ ...a, [k.value]: k.label }), {});

export const EINSATZARTEN = [
  "Staatsanwalt-Gespräch",
  "Anwalt-Gespräch",
  "EMS-Gespräch",
  "Besucher-Normal",
  "Gericht-Einsatz",
  "Großabholung (Bus)",
  "Abhandlung-Besucherraum",
  "Sonstiges",
  "Einsatz",
  "Parole",
];

export const CHAINGANG_STATUS = [
  { value: "Anfrage | Stattgefunden", positive: true },
  { value: "Angeboten | Stattgefunden", positive: true },
  { value: "Anweisung | Stattgefunden", positive: true },
  { value: "Anfrage | Nicht Stattgefunden", positive: false },
  { value: "Angeboten | Nicht Stattgefunden", positive: false },
];

export const CHAINGANG_STATUS_VALUES = CHAINGANG_STATUS.map((s) => s.value);
export const CHAINGANG_STATUS_MAP = CHAINGANG_STATUS.reduce(
  (a, s) => ({ ...a, [s.value]: s.positive }),
  {}
);

export const GEFAHRENSTUFEN = [
  { value: "Gefahrenstufe 1", color: "green" },
  { value: "Gefahrenstufe 2", color: "orange" },
  { value: "Gefahrenstufe 3", color: "red" },
];
export const GEFAHRENSTUFE_VALUES = GEFAHRENSTUFEN.map((g) => g.value);
export const GEFAHRENSTUFE_COLOR = GEFAHRENSTUFEN.reduce((a, g) => ({ ...a, [g.value]: g.color }), {});

export const ORTUNG = [
  { value: "Grün", color: "green" },
  { value: "Gelb", color: "yellow" },
  { value: "Rot", color: "red" },
];
export const ORTUNG_VALUES = ORTUNG.map((o) => o.value);
export const ORTUNG_COLOR = ORTUNG.reduce((a, o) => ({ ...a, [o.value]: o.color }), {});

export const HOECHSTSTRAFEN = [
  "Ordnungswidrigkeit",
  "Vergehen",
  "Verbrechen",
  "Schwer Verbrechen",
  "Mord",
];
export const HOECHSTSTRAFE_MONTHS = {
  Ordnungswidrigkeit: 1,
  Vergehen: 2,
  Verbrechen: 4,
  "Schwer Verbrechen": 8,
};

export const LZ_GEFAHRENSTUFEN = [
  { value: "Niedrig", color: "green" },
  { value: "Mittel", color: "amber" },
  { value: "Hoch", color: "red" },
  { value: "Sehr Hoch", color: "black" },
];
export const LZ_GEFAHRENSTUFE_VALUES = LZ_GEFAHRENSTUFEN.map((g) => g.value);
export const LZ_GEFAHRENSTUFE_COLOR = LZ_GEFAHRENSTUFEN.reduce((a, g) => ({ ...a, [g.value]: g.color }), {});
export const LZ_GESCHLECHT = ["Männlich", "Weiblich", "Divers"];

export const EXTERNE_KATEGORIEN = [
  { value: "sadcr_relevant", label: "SADCR Relevant" },
  { value: "pd_allgemein", label: "PD allgemein" },
  { value: "iad_ssg", label: "IAD / SSG" },
];

export const HAFTRECHNER = {
  RATE_GELD_PRO_HE: 1000, // 1000 Geld = 1 HE
  MIN_PRO_HE: 60, // 1 HE = 60 Minuten
  ANWALT: ["Nein", "Ja"],
  KOOPERATIV: ["Kooperativ", "Nicht kooperativ"],
  VORSTRAFEN: ["beachtet", "nicht beachtet"],
  BEGRUENDUNG: ["Kein Vorsatz", "Vorsatz"],
  ZAHLUNGSART: ["Zahlt", "Verweigert die Zahlung", "Kann nicht zahlen"],
};

export const todayISO = () => new Date().toISOString().slice(0, 10);

// Temporär: Login deaktiviert. Auf false setzen, um Auth wieder zu aktivieren.
export const AUTH_DISABLED = false;
export const DEV_USER = { id: "dev", name: "Officer", dienstnummer: "0000", rang: "Director", role: "officer" };

export const formatDatum = (v) => {
  if (!v) return "—";
  const d = new Date(v);
  if (isNaN(d)) return v;
  return d.toLocaleDateString("de-DE", { day: "2-digit", month: "2-digit", year: "numeric" });
};
